<div class="table" [attr.data-cols]="getTotalColumnCount()">
  <div class="table-row table-header-row">
    <div
      class="cell table-header shrink center-children-vertically"
      data-col="select"
      *ngIf="select.observed && showCheckbox"
    >
      <app-checkbox [formControl]="allSelectForm"/>
    </div>
    <div
      class="cell table-header grow row gap center-children-vertically"
      *ngFor="let headerColumnName of getColumnName(); let colIndex = index"
      [attr.data-col]="'c' + colIndex"
      [class.pointer]="getColumnConfig(headerColumnName).sortable"
      (click)="sortColumn(headerColumnName)"
    >
      <div class="header-column-name">{{ getColumnConfig(headerColumnName).displayName }}</div>
      <div class="column text-small" *ngIf="getColumnConfig(headerColumnName).sortable">
        <app-icon size="12" type="chevron-up" *ngIf="lastSortOption$.value?.sort !== headerColumnName || (lastSortOption$.value?.sort === headerColumnName && lastSortOption$.value?.order !== 'DESC')" />
        <app-icon size="12" type="chevron-down" *ngIf="lastSortOption$.value?.sort !== headerColumnName || (lastSortOption$.value?.sort === headerColumnName && lastSortOption$.value?.order !== 'ASC')"/>
      </div>
    </div>
    <div class="cell table-header shrink" data-col="goto" *ngIf="goTo.observed"></div>
  </div>

  <div class="table-row" *ngFor="let item of items; let index = index">
    <div
      class="cell shrink center-children-vertically"
      data-col="select"
      *ngIf="select.observed && showCheckbox"
    >
      <app-checkbox [formControl]="selectionCheckboxes[index].form"/>
    </div>
    <div
      class="cell grow center-children-vertically"
      *ngFor="let headerColumnName of getColumnName(); let colIndex = index"
      [attr.data-col]="'c' + colIndex"
      [style]="getColumnConfig(headerColumnName)?.styleFunction ? getColumnConfig(headerColumnName)?.styleFunction(getItemValue(item, headerColumnName)) : getColumnConfig(headerColumnName).style"
    >
      <ng-container *ngIf="getColumnConfig(headerColumnName).customTemplate; else defaultCell">
        <ng-container *ngTemplateOutlet="getColumnConfig(headerColumnName).customTemplate!; context: { $implicit: item, value: getItemValue(item, headerColumnName) }"></ng-container>
      </ng-container>
      <ng-template #defaultCell>
        {{ getColumnConfig(headerColumnName)?.transformFunction ? getColumnConfig(headerColumnName)?.transformFunction(getItemValue(item, headerColumnName), item) : getItemValue(item, headerColumnName) }}
      </ng-template>
    </div>
    <div
      class="cell shrink pointer center-children-vertically base-padding"
      data-col="goto"
      *ngIf="goTo.observed"
      (click)="goToRow(item)"
    >
      <app-icon type="chevron-right"/>
    </div>
  </div>
</div>
